import React, { createContext, useContext, useState } from 'react';

const TimesheetContext = createContext();

export const TimesheetProvider = ({ children }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [timesheets, setTimesheets] = useState([]);
  const [filteredSheets, setFilteredSheets] = useState(null);
  const [searchInputs, setSearchInputs] = useState({});
  const [searchVisible, setSearchVisible] = useState({});
  const [hasFetched, setHasFetched] = useState(false);

  return (
    <TimesheetContext.Provider value={{ 
      startDate, 
      setStartDate, 
      endDate, 
      setEndDate,
      timesheets,
      setTimesheets,
      filteredSheets,
      setFilteredSheets,
      searchInputs,
      setSearchInputs,
      searchVisible,
      setSearchVisible,
      hasFetched,
      setHasFetched
    }}>
      {children}
    </TimesheetContext.Provider>
  );
};

export const useTimesheet = () => useContext(TimesheetContext);

